import React, {useState} from 'react';

import {Column, Row} from '../../../components/layout';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {setWizard} from '../../../store/actions';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../components/forms';
import * as Yup from 'yup';
import {strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import './styles.scss';

export interface BeforeContinueCMDProps {
  labels: typeof strings.pt.registoCMD;
  messageLabels: typeof strings.pt.messages;
  labelsLogin: typeof strings.pt.login;
  oneTrust: typeof strings.pt.oneTrust;
  onSubmit(value: any): void;
}

function BeforeContinueCMD({
  onSubmit,
  messageLabels,
  labels,
  labelsLogin,
  oneTrust,
}: BeforeContinueCMDProps) {
  const [values, setValues] = useState({
    acceptedTermsAndConditions: false,
    acceptedDataTreatment: false,
  });

  const validationSchema = Yup.object().shape({
    acceptedTermsAndConditions: Yup.boolean()
      .required(messageLabels.requiredField)
      .oneOf([true]),
    acceptedDataTreatment: Yup.boolean()
      .required(messageLabels.requiredField)
      .oneOf([true]),
  });

  return (
    <Column className="communications-container-column">
      <AppForm
        className="communications-form-container"
        initialValues={{
          acceptedTermsAndConditions: false,
          acceptedDataTreatment: false,
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => onSubmit(values)}
        onChange={setValues}>
        <Row className="center">
          <Column>
            <Row>
              <p
                style={{...fonts.ML}}
                className="register-before-continue-subtitle1">
                {labels?.registoCMD_beforeContinueSubtitle}
              </p>
            </Row>
            <Row>
              <Column className="insurance-validation-checkboxes">
                <AppFormCheckboxField
                  showErrorMessage
                  purposeId={oneTrust?.purposeTermsAndConditions}
                  name="acceptedTermsAndConditions"
                  label={
                    <label
                      className="align-left-label"
                      style={{
                        textAlign: 'start',
                        ...fonts.SM,
                        ...fonts.Medium,
                      }}>
                      {labels?.registoCMD_beforeContinueCheckbox1}{' '}
                      <a
                        className="insurance-validation-anchors"
                        href={labelsLogin?.login_acceptConditionsUrl}
                        target="_blank">
                        {labels?.registoCMD_beforeContinueCheckbox1Link}
                      </a>
                    </label>
                  }
                  labelClass="checkboxes-label"
                />
                <AppFormCheckboxField
                  showErrorMessage
                  purposeId={oneTrust?.purposePolicyDataTreatment}
                  name="acceptedDataTreatment"
                  label={
                    <label
                      className="align-left-label"
                      style={{...fonts.SM, ...fonts.Medium}}>
                      {labels?.registoCMD_beforeContinueCheckbox2}{' '}
                      <a
                        className="insurance-validation-anchors"
                        href={labelsLogin?.login_acceptPrivacyPolicyUrl}
                        target="_blank">
                        {labels?.registoCMD_beforeContinueCheckbox2Link}
                      </a>
                    </label>
                  }
                  labelClass="checkboxes-label"
                />
              </Column>
            </Row>
            <Row className="app-center">
              <AppFormSubmitButton
                className="communications-button"
                title={labels?.registoCMD_beforeContinueButton}
                disabled={
                  !values.acceptedTermsAndConditions ||
                  !values.acceptedDataTreatment
                }
              />
            </Row>
          </Column>
        </Row>
      </AppForm>
    </Column>
  );
}

const mapStateToProps = ({stringsDefault, strings}: any) => ({
  messageLabels: strings.value.pt.messages,
  labels: stringsDefault.value.pt.registoCMD,
  labelsLogin: stringsDefault.value.pt.login,
  oneTrust: stringsDefault.value.pt.oneTrust,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(BeforeContinueCMD),
);
